import { MatchModelBase, SoccerMatchModel } from '@nf/types/odds';
import { UserInfo } from '@nf/types/account';

export interface TimeMachineTimeProps {
	match: MatchModelBase;
	isCurrentMatchTime: boolean;
	isPlusMatchTime: boolean;
}

export const GetTimeMachineTime = (Match: MatchModelBase, tmIntervalTime: number, isCurrentMatchTime: boolean = false, isPlusMatchTime: boolean = false) => {
	const iTime = isCurrentMatchTime ? 0 : tmIntervalTime;
	const is1H = !!~(Match.ShowTime?.indexOf('1H') ?? -1);
	const is2H = !!~(Match.ShowTime?.indexOf('2H') ?? -1);
	const isHalf = !!~(Match.ShowTime?.indexOf('Ref_htime') ?? -1);
	const timeMatch = Match.ShowTime?.match(/\d+/g);
	if (!timeMatch) return ((isHalf ? 45 : 0) + iTime);
	const MatchTime = (Number(timeMatch.length > 1 ? timeMatch[1].replace('\'', '') : timeMatch[0].replace('\'', '')) + (is2H ? 45 : 0));
	if (isPlusMatchTime) return (MatchTime + iTime);

	if (!Match.IsLive) {
		return tmIntervalTime
	}
	return ((is1H && MatchTime >= 45) ? 45 : ((is2H && (MatchTime + iTime) >= 90) ? (90 - iTime) : MatchTime == 0 ? 1 : MatchTime)) + iTime;
}

export const HasTimeMachine = (match: MatchModelBase, accountInfo?: UserInfo | null) => {
	const tmIntervalTime = accountInfo?.TMINR ?? 6;

	const tmhdp = accountInfo?.TMHDP
	const TM = accountInfo?.TM
	const htm = (match as SoccerMatchModel).htm;
	// 0: none,
	// 1: only 228,
	// 2: only 229,
	// 3: 228 and 229
	// if (this.get('type') === 'parlay') return;
	return (TM && !!htm && !(!tmhdp && htm === 2) && GetTimeMachineTime(match, tmIntervalTime, false, true) <= 91) || false;
}

export const TimeMachineService = {
	GetTimeMachineTime,
	HasTimeMachine,
}